<template>
  <div>
    <h3 class="mb-2 font-weight-bold text-center">
      De quoi avez-vous besoin?
    </h3>
    <b-row>
      <!-- Bug Report -->
      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card
          class="ticket-type-card bug-card text-center cursor-pointer hover-lift"
          @click="$emit('type-selected', 'bug')"
        >
          <div class="icon-wrapper bg-light-danger">
            <feather-icon
              icon="AlertOctagonIcon"
              size="56"
              class="text-danger"
            />
          </div>
          <h4 class="mb-75 mt-1 font-weight-bold">
            Signaler un Bug
          </h4>
          <p class="card-text mb-0">
            Quelque chose ne fonctionne pas correctement
          </p>
        </b-card>
      </b-col>

      <!-- Feature Request -->
      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card
          class="ticket-type-card feature-card text-center cursor-pointer hover-lift"
          @click="$emit('type-selected', 'feature')"
        >
          <div class="icon-wrapper bg-light-primary">
            <feather-icon
              icon="LightbulbIcon"
              size="56"
              class="text-primary"
            />
          </div>
          <h4 class="mb-75 mt-1 font-weight-bold">
            Demander une Fonctionnalité
          </h4>
          <p class="card-text mb-0">
            Suggérer une nouvelle fonctionnalité ou amélioration
          </p>
        </b-card>
      </b-col>

      <!-- Technical Support -->
      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card
          class="ticket-type-card support-card text-center cursor-pointer hover-lift"
          @click="$emit('type-selected', 'technical')"
        >
          <div class="icon-wrapper bg-light-success">
            <feather-icon
              icon="MessageCircleIcon"
              size="56"
              class="text-success"
            />
          </div>
          <h4 class="mb-75 mt-1 font-weight-bold">
            Support Technique
          </h4>
          <p class="card-text mb-0">
            Obtenir de l'aide technique
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'

export default {
  name: 'TicketTypesSelection',
  components: {
    BRow,
    BCol,
    BCard,
  },
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.ticket-type-card {
  border: 2px solid transparent;
  padding: 2rem 1.5rem;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, transparent, currentColor, transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);

    &::before {
      opacity: 1;
    }
  }

  &.bug-card {
    &:hover {
      border-color: rgba(234, 84, 85, 0.2);
      background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);
    }

    &::before {
      color: #ea5455;
    }
  }

  &.feature-card {
    &:hover {
      border-color: rgba(115, 103, 240, 0.2);
      background: linear-gradient(135deg, #fff 0%, #f5f4ff 100%);
    }

    &::before {
      color: #7367f0;
    }
  }

  &.support-card {
    &:hover {
      border-color: rgba(40, 199, 111, 0.2);
      background: linear-gradient(135deg, #fff 0%, #f0fdf7 100%);
    }

    &::before {
      color: #28c76f;
    }
  }

  .icon-wrapper {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    transition: all 0.3s ease;
  }

  &:hover .icon-wrapper {
    transform: scale(1.1) rotate(5deg);
  }

  h4 {
    font-size: 1.25rem;
    color: #5e5873;
  }

  .card-text {
    color: #6e6b7b;
    font-size: 0.95rem;
    line-height: 1.5;
  }
}

h3 {
  color: #5e5873;
  font-size: 1.75rem;
}
</style>
